import { api } from '@/services'

export const findAll = () => {
  return api.get('/admin/partner/findAll')
}

export const list = (params) => {
  return api.get('/admin/partner/list', { params: params })
}

export const show = (id) => {
  return api.get(`/admin/partner/show/${id}`)
}

export const createUpdate = (body) => {
  return body?.id 
    ? api.put(`/admin/partner/update/${body.id}`, body) 
    : api.post('/admin/partner/create', body)
}

export const remove = (id) => {
  return api.delete(`/admin/partner/delete/${id}`)
}